import { render, staticRenderFns } from "./ResidentialStatus.vue?vue&type=template&id=70ee1bbe&scoped=true"
import script from "./ResidentialStatus.vue?vue&type=script&lang=js"
export * from "./ResidentialStatus.vue?vue&type=script&lang=js"
import style0 from "./ResidentialStatus.vue?vue&type=style&index=0&id=70ee1bbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee1bbe",
  null
  
)

export default component.exports